import { createStylesUtils } from './common/common';

export const loginStyles = createStylesUtils({
  container: {
    position: 'fixed',
    top: 0,
    bottom: 0,
    width: '100%',
    height: '100%',
  },

  input: {
    width: '90%',
    maxWidth: '500px',
  },
});
